<script setup>
import { computed } from 'vue'
import AgentMarkdown from '../AgentMarkdown.vue'
import {
  isToolPart,
  reasoningDisplayFromText,
  textFromContent,
} from '../BidBoostLangGraphTransport'
import ActivityReasoning from './ActivityReasoning.vue'
import ActivityToolGroup from './ActivityToolGroup.vue'

const props = defineProps({
  parts: { type: Array, default: () => [] },
  status: { type: String, default: 'complete' },
})

const entries = computed(() => {
  const items = []
  for (const [index, part] of props.parts.entries()) {
    const id =
      part.id ||
      part.toolCallId ||
      `${part.sourceMessageId || 'activity'}-${index}`
    if (isToolPart(part)) {
      const previous = items.at(-1)
      if (previous?.type === 'tools') previous.parts.push(part)
      else items.push({ id, type: 'tools', parts: [part] })
      continue
    }
    if (part.type === 'reasoning') {
      const reasoning = reasoningDisplayFromText(part.text)
      const title = part.title || reasoning.title
      if (reasoning.text || title) items.push({ id, type: 'reasoning', part })
    } else if (part.type === 'text' && textFromContent(part.text).trim()) {
      items.push({ id, type: 'text', text: textFromContent(part.text) })
    }
  }
  return items
})
</script>

<template>
  <div class="min-w-0 space-y-3">
    <template v-for="entry in entries" :key="entry.id">
      <ActivityToolGroup
        v-if="entry.type === 'tools'"
        :parts="entry.parts"
        :status="status"
      />
      <ActivityReasoning
        v-else-if="entry.type === 'reasoning'"
        :part="entry.part"
        :status="status"
      />
      <div
        v-else
        class="min-w-0 space-y-1"
        :data-testid="`activity-${entry.type}`"
      >
        <AgentMarkdown
          v-if="entry.text"
          :content="entry.text"
          variant="reasoning"
        />
      </div>
    </template>
  </div>
</template>
